<template>
  	<div>

    	<multiselect 
					v-model="OPZIONE_SELEZIONATA" 
					:track-by="'id'" 
					:value="'Integer'"
					:placeholder="placeholder" 
					open-direction="bottom" 
					:options="opzioniVisibili" 
					@select="formattaInUscita"
					:multiple="false" 
					:searchable="true" 
					:loading="isLoading" 
					:internal-search="locale" 
					label="text" 
					:clear-on-select="false" 
					:close-on-select="true" 
					:options-limit="limiteAnteprima" 
					:limit="limiteAnteprima" 
					:max-height="600" 
					:show-no-results="false" 
					:hide-selected="true" 
					@search-change="asyncFind"
					:selectLabel="''"
					:disabled="disabled"
					>
					<!-- 
					<div class="multiselect__clear" v-if="selectedCountries.length" @mousedown.prevent.stop="clearAll(props.search)"></div>
					-->
					<template v-slot:clear >
						<div class="multiselect__clear" v-if=" this.currentId > 0" @mousedown.prevent.stop="clearAll()"></div>
					</template>
					<template v-slot:noOptions >{{ nessunRisultato }}</template>
					<template v-slot:option="{ option }">
						<span :class="{'opacity-50': msgInattivo && option.ATTIVO == 0}">{{ option.text }}</span>
					</template>

					
		</multiselect>
  	</div>
</template>


<script>
import { computed,ref } from 'vue'
import Multiselect from 'vue-multiselect'
import { utils } from '../../assets/js/utils';



/* B2.1C-01E.6 - METODO HTTP CONFIGURABILE
   Default "POST": preserva ESATTAMENTE il comportamento storico di Select2.
   Con "GET" si usa utils.get(), che passa il metodo per esplicito.
   Serve alle route registrate solo con $app->get(): con il POST di default
   permDeriveAzione ricava ..._CREATE invece di ..._READ e la richiesta
   veniva negata dal gate permessi. */
function chiamaApi(utilsRif, api, args, cb, metodo) {
if ((metodo || "POST") === "GET") {
utilsRif.get(api, args, cb, false);
} else {
utilsRif.ajax(api, args, cb, false);
}
}

export default {
	name: 'Select2',

	components:{
		Multiselect
	},

	data() {
		return {
			opzioni:new Array(),
			isLoading:false,
			/* B2.1C-01E.2: le opzioni REMOTE restano qui. La prop "options"
			   (modalita' locale) non puo' avere lo stesso nome del data. */
			opzioniRemote:new Array(),
			currentId:0,
			isWriting : false,
			currentQuery:"",
			lastApi:"",
			/* testo cercato, usato solo in modalita' locale */
			queryLocale:""
		};
	},

  	emits: ['update:modelValue','selectedItem'],

  	setup(props, { emit,ref,getCurrentInstance,context }) {
	
		const CURRENT_TIME = new Date().getTime();
		const cacheSelected = (t, data) => {
			var arr = (Array.isArray(data) ? data : [data]).filter(x => x != null && x.id != null);
			utils.appoggio['select2_'+CURRENT_TIME] = arr.length > 0 ? arr : [{id: t, text: '-'}];
		};
		const OPZIONE_SELEZIONATA = computed({          	
			get: () => {
				var t = props.modelValue;
				if (t == undefined || t == null){
					return {id: 0,text:'Selezionare un elemento'};
				}
				var underscore = (t.toString().search("_") > -1);
				if (isNaN(t) && underscore == false){
					return {id: 0,text:'Selezionare un elemento'};
				}		
				else{
					if (t != undefined && underscore == false && t > 0){
						//console.log(" B ");
						var arr = utils.appoggio['select2_'+CURRENT_TIME];
						//SE HO IN CASA UN array valorizzato correttamente, valorizzo la input
						if (arr != undefined && arr.length > 0){
							var item = null;
							for (var kk = 0 ; kk < arr.length ; kk++){
								if (arr[kk] == null || arr[kk].id == null) continue;
								if (arr[kk].id.toString().search("_") > -1){
									var split = arr[kk].id.split("_");
									for (var zz = 0 ; zz < split.length ; zz++ ){
										if (split[zz] == t){
											return {id: t,text:arr[kk].text};
										}
									}
								}
								else{
									if (arr[kk].id == t){
										item = utils.clone(arr[kk]);
									}
								}
							}

							//var item = utils.array.select(arr,"id",t,1)[0];
							if (item != undefined){
								return {id: t,text:item.text};
							}     
							else{
								if (props.apiselected != null){
									chiamaApi(utils, props.apiselected, {q:t}, (response) => {
										cacheSelected(t, response && response.data);
										emit('update:modelValue',"_"+t);
									}, props.httpMethod);
									return {id: 0,text:'-'};
								}
								else{
									return {id: 0,text:'-'};
								}
								
							}         							
						}
						else{
							//SE NON HO UN array VALORIZZATO, E HO LE API PER FARE UNA CHIAMATA, PROVO A FARE LA CHIAMATA
							if (props.apiselected != null && props.apiselected != ''){
								chiamaApi(utils, props.apiselected, {q:t}, (response) => {
									cacheSelected(t, response && response.data);
									emit('update:modelValue',"_"+t);
								}, props.httpMethod);								
								return {id: 0,text:'Loading'};
							}
							else{
								return {id: 0,text:'Selezionare un elemento'};
							}
						}						
					}
					//SE E' STATO VALORIZZATO IN PRECDENZA E E' STATA FATTA LA CHIAMATA PER RECUPERARE L'ELEMENTO
					else if (t != undefined && underscore == true){
						//console.log(" A ");
						var arr = utils.appoggio['select2_'+CURRENT_TIME];
						var arraySplit = t.split("_");
						//MODIFICATO 12/12/2025
						for (var i = 0 ; i < arraySplit.length ; i++){
							if (arraySplit[i] != 0){
								emit('update:modelValue',arraySplit[i]);
								/*
								var item = utils.array.select(arr,"id",t,1)[0];
								if (item != undefined){
									return {id: t,text:item.text};
								}    */
								return {id: 0,text:'Loading'};          								
							}
						}
						return {id: 0,text:'Loading'};   

					}
					else{
						return {id: 0,text: props.placeholder};
					}
				}	
			},
			set : (newVal) => {
				if (newVal == null || newVal.hasOwnProperty("id") == false){
					emit('selectedItem',newVal);
					return newVal;
				}
				emit('selectedItem',newVal.id);
				return newVal;
			}
		});
		return { OPZIONE_SELEZIONATA, CURRENT_TIME };
  	},

	props: {
		modelValue: [String, Array, Number, Object], // previously was `value: String`
		placeholder: {
			type: String,
			default: ''
		},
		api : {
			type : String,
			default:null
		},
		/* B2.1C-01E.2 - MODALITA' LOCALE (opzionale).
		   Se valorizzata: NESSUNA chiamata API, ricerca locale case-insensitive
		   sull'intero dataset, massimo 5 risultati, stessa UX della modalita' remota
		   (dropdown, chiusura dopo la selezione, clear, stili).
		   Se NON valorizzata: comportamento remoto identico a sempre, zero regressioni. */
		options : {
			type : Array,
			default : null
		},
		/* B2.1C-01E.6: metodo HTTP usato sia per la ricerca sia per il resolver
   del valore selezionato. Default "POST" = comportamento storico. */
	/* B2.1C-01F: parametri extra SOLO nella richiesta di anteprima (query vuota con 	   loadOnOpen). Default {} = nessun parametro aggiunto, quindi le Select2 	   esistenti non cambiano. Esempio CORE: /core/geo/comuni/select2 accetta 	   FORCE per l'elenco iniziale, senza dover digitare. */ 	forceParams:{ 		type : Object, 		default : () => ({}) 	},
/* B2.1C-01E.7: minimo di caratteri per la ricerca DIGITATA.
   Default 3 = comportamento storico di tutte le Select2 remote. */
minChars:{
type : Number,
default : 3
},
/* B2.1C-01E.7: carica gia' un elenco con query vuota all'apertura.
   Default false = comportamento storico (serve digitare). */
loadOnOpen:{
type : Boolean,
default : false
},
httpMethod:{
type : String,
default : "POST"
},
apiselected:{
			type : String,
			default : null
		}, 
		disabled:{
			type : Boolean,
			default : false
		},
		/* se valorizzato, le opzioni con ATTIVO == 0 sono semitrasparenti e non selezionabili */
		msgInattivo:{
			type : String,
			default : null
		},
	},

	computed: {
		/* true quando questo Select2 riceve le opzioni gia' in memoria */
		locale () { return Array.isArray(this.options); },
		/* Stesso limite di CLIENTE in entrambe le modalita': 5 risultati visibili. */
		limiteAnteprima () { return 5; },
		/* Elenco mostrato: in locale arriva gia' filtrato, in remoto com'e'. */
		opzioniVisibili () {
			if (!this.locale) return this.opzioniRemote;
			const q = (this.queryLocale || "").trim().toLowerCase();
			/* B2.1C-01E.3: il dataset sorgente non e' mai troncato PRIMA della ricerca.
			   Si filtra su tutto e si tronca SOLO il risultato mostrato, sia a
			   dropdown aperto (q vuota) sia durante la ricerca. */
			if (q === "") return this.opzioni.slice(0, this.limiteAnteprima);
			/* La ricerca guarda TUTTO il dataset; il troncamento a 5 riguarda
			   solo cio' che viene mostrato, mai la ricerca. */
			return this.opzioni.filter((o) => {
				const t = o && o.text != null ? String(o.text).toLowerCase() : "";
				return t.indexOf(q) >= 0;
			}).slice(0, this.limiteAnteprima);
		},
		nessunRisultato () {
			/* B2.1C-01E.7: con l'anteprima attiva non ha senso chiedere di digitare. */
			if (this.locale || this.loadOnOpen) return "Nessun risultato";
			return "Scrivi min. " + this.minChars + " caratteri";
		},
	},
	watch: {
		/* B2.1C-01E.2: in locale si semina la cache che risolve il modelValue al primo
		   render, cosi' NON serve chiamare apiselected. */
		options: {
			immediate: true,
			handler (v) {
				if (!Array.isArray(v)) return;
				this.opzioni = v;
				const t = this.modelValue;
				if (t != null && t !== "" && Number(t) > 0) {
					utils.appoggio['select2_' + this.CURRENT_TIME] = v;
				}
			},
		},
		modelValue: {
			handler(val) {
				this.formattaInUscita(val);
			},
			deep: true
		},
		api: {
			/* B2.1C-01E.4: senza "immediate" il primo caricamento non avveniva mai
			   per le select con api costante (Progetto): il watcher scatta solo se
			   l'api CAMBIA, e quella non cambia mai. Cliente invece si popolava per
			  che' apiCliente cambia scegliendo la tipologia: da li' la differenza.
			   Con immediate ogni Select2 remota fa il primo carico, quindi tutte
			   si comportano come Cliente. */
			immediate: true,
			handler(val) {
				if (val && val != this.lastApi){
					this.lastApi = val;
					this.opzioniRemote = new Array();
					this.currentQuery = "";
					this.doFind();
				}
			}
		},
	},

  	methods: {
		asyncFind (query) {
			/* B2.1C-01E.2: in locale NON si esce dal browser; il filtro lo fa
			   vue-multiselect su opzioniVisibili. In remoto il flusso e' invariato. */
			if (this.locale) { this.queryLocale = query || ""; return; }
			this.opzioniRemote = new Array();
			/* B2.1C-01E.7: svuotando la casella si torna all'anteprima (solo se
			   loadOnOpen). La soglia della ricerca digitata resta quella storica. */
			if (this.loadOnOpen && (query == null || String(query).trim() === "")){
				this.currentQuery = "";
				this.doFind();
				return;
			}
			if (query.length > this.minChars - 1){
				this.currentQuery = query;
				utils.wait(()=>{
					if (this.currentQuery == query) {
						this.doFind();
					}
				},500);			
			}
		},
		doFind(){
			/* B2.1C-01E.2: mai in modalita' locale -> zero chiamate API. */
			if (this.locale) return;
			/* B2.1C-01E.5: il primo caricamento automatico mandava q="" (richiesta
			   inutili: il resolver progetti scarta sotto i 3 caratteri). Con q vuoto
			   NON si esce dal browser: niente spinner, niente request inutile. */
			if ((this.currentQuery == null || String(this.currentQuery).trim() === "") && !this.loadOnOpen){
				this.opzioniRemote = [];
				this.isLoading = false;
				return;
			}
			this.isLoading = true;
			/* B2.1C-01E.5: isLoading deve tornare false in OGNI percorso terminale
			   (successo, esito applicativo != 0, errore HTTP/rete, eccezione).
			   Prima l'assegnazione stava DENTRO il callback: se la risposta non
			   aveva "data" o il fetch falliva, il callback non arrivava e lo
			   spinner restava attivo all'infinito. */
			try {
				const __q = this.currentQuery == null ? "" : String(this.currentQuery).trim();
			const __args = (__q === "" && this.loadOnOpen && this.forceParams && Object.keys(this.forceParams).length)
				? Object.assign({}, this.forceParams)
				: { q: this.currentQuery };
			chiamaApi(utils, this.api, __args, (response) => {
					/* Una risposta applicativa negativa (es. esito=1 "Operazione non
					   consentita") NON e' un successo: semplicemente non popola, e
					   lascia comunque lo spinner fermo. L'errore non viene mascherato. */
					const dati = (response && Array.isArray(response.data)) ? response.data : [];
					this.opzioniRemote = dati;
					utils.appoggio['select2_'+this.CURRENT_TIME] = dati;
					this.isLoading = false;
				}, this.httpMethod);
			} catch (e) {
				this.opzioniRemote = [];
				this.isLoading = false;
			}
			/* Rete: fetch rifiutato o timeout -> nessun callback, spinner fermo. */
			if (this.isLoading) {
				this.isLoading = false;
			}
		},
		formattaInUscita(selectedOption,id){
			if (selectedOption != undefined){
				if (selectedOption.hasOwnProperty("id")){
					if (this.msgInattivo && selectedOption.ATTIVO == 0){
						utils.alert.warning(this.msgInattivo);
						return;
					}
					this.$emit('update:modelValue',selectedOption.id);
					this.currentId = selectedOption.id
				}
				else{
					if (selectedOption > 0){
						this.currentId = selectedOption;
						this.$emit('update:modelValue',selectedOption);
					}          
				}
			}
    	},
		clearAll:function(){
			this.selectedOption = {id:0,text:''}	;
			this.currentId = 0;
			this.formattaInUscita(this.selectedOption,0);
		},
		
		setOption(val = []) {      
			this.setValue(this.modelValue);
		},

    	setValue(val) {
			if (val instanceof Array) {
				/*
				this.select2.val([...val]);
				this.select2.trigger('change');
				*/
			} 
        	else {
					/* B2.1C-01E.2: in locale l'id si risolve dalla lista in memoria, senza apiselected. */
					if (this.locale){
						return;
					}
					if (this.apiselected != null && val > 0){
					chiamaApi(global.utils, this.apiselected, {q:val}, (response) => {
						if (response.hasOwnProperty('data')){
							this.$forceUpdate();
						}
				}, this.httpMethod);
				}
				else{
					/*
					this.select2.val([val]);
					this.select2.trigger('change');
					*/
				}
      		}
    	},

		onSelect : function(){
			//console.log("alerting");
			//this.changeHandler();
		}

	},

  	mounted() {
		this.GET_OPZIONI = () => {
			return this.locale ? this.opzioni : this.opzioniRemote;
		}
    	return;
	},
};
</script>
